{
  "_provenance": {
    "ns": "money",
    "source": "expenses, receipts and the ledger: components/expenses/** and lib/money.ts — gated, ships machine behind the banner (R3-B7) (#2109 R3 lane L4)"
  },
  "capture": {
    "added": "Added — reading it now",
    "body": "A photo or a PDF. We read the merchant, date, amount and category for you; you can fix anything we get wrong.",
    "cameraInput": "Take a photo of the receipt",
    "choose": "Choose a file",
    "fileInput": "Receipt file",
    "inReceipts": "Added — it’s in your receipts",
    "needsDetails": "{{what}} — add the missing details",
    "photo": "Take a photo",
    "seeIt": "See it",
    "sent": "{{what}} — sent to TRF for review",
    "title": "Drop a receipt here",
    "tooLarge": "Larger than {{size}} MB",
    "unreadable": "We couldn’t read it — add the details",
    "uploadFailed": "Upload failed",
    "uploading": "Uploading…",
    "wrongType": "Only JPEG, PNG or PDF files can be added."
  },
  "category": {
    "home_utilities": "Utilities",
    "other": "Other",
    "rent": "Rent",
    "travel": "Travel"
  },
  "chatReceipt": {
    "amountError": "Enter the amount on the receipt (more than {{min}}).",
    "amountLabel": "Amount on the receipt",
    "amountPlaceholder": "Amount",
    "categoryLabel": "Expense category",
    "done": "Done",
    "openGrants": "Open Grants",
    "submit": "Submit receipt",
    "submitted": "Receipt sent — follow it on your Grants page.",
    "submitting": "Submitting…",
    "threadLine": "Receipt sent: {{name}}. Follow it on your Grants page.",
    "title": "Attach a receipt"
  },
  "details": {
    "add": "Add expense",
    "addNewReceipt": "Add a new receipt",
    "addReceipt": "Add receipt",
    "amountLabel": "Amount",
    "categoryLabel": "Category",
    "decisionReasonLabel": "Why it wasn’t approved",
    "eyebrowEdit": "Edit expense",
    "eyebrowNew": "New expense",
    "eyebrowReadOnly": "Expense",
    "footerComplete": "Complete — saving sends it to TRF.",
    "footerMissingDetails": "Add the missing details to send it to TRF.",
    "footerMissingReceipt": "Add the receipt to send it to TRF.",
    "footerNotApproved": "This receipt wasn’t approved. You can add a new receipt with what’s needed.",
    "footerReadOnly": "This expense is with TRF; it can no longer be edited here.",
    "needsInfoReasonLabel": "What TRF needs from you",
    "noteLabel": "What was it for? (optional)",
    "notePlaceholder": "e.g. Gas on the drive to the clinic",
    "ocr": "Read from the receipt: {{summary}}",
    "ocrWithAmount": "Read from the receipt: {{summary}} · {{amount}}",
    "receiptAlt": "Receipt",
    "receiptFile": "Receipt file",
    "receiptLabel": "Receipt",
    "receiptMissing": "No receipt yet",
    "receiptNone": "No receipt yet.",
    "receiptPdf": "PDF receipt",
    "replaceReceipt": "Replace receipt",
    "replyHint": "Your reply and any changes above go back to TRF together.",
    "replyLabel": "Your reply to TRF",
    "replyPlaceholder": "Answer or explain what TRF asked",
    "replySend": "Reply and send back",
    "titleFallback": "Receipt",
    "titleNew": "What did you pay for?",
    "vendorLabel": "Where was it?",
    "vendorPlaceholder": "e.g. Shell, Marriott, Duke Energy",
    "whenLabel": "When"
  },
  "ledger": {
    "attention": "Needs your attention",
    "emptyBody": "Add a receipt and we read the merchant, date and amount for you. Every expense TRF reimburses lives here, with its receipt.",
    "emptyCta": "Add a receipt",
    "emptyTitle": "No expenses yet",
    "loadFailed": "Couldn’t load your expenses.",
    "loading": "Loading your expenses…",
    "noDate": "No date",
    "noMatch": "No expenses match."
  },
  "ledgerStatus": {
    "approved": "Approved",
    "arranging": "Approved — we’re arranging your payment",
    "needs_details": "Needs details",
    "needs_info": "TRF needs more information",
    "needs_receipt": "Needs receipt",
    "paid": "Paid back",
    "paying": "Payment on its way",
    "rejected": "Not approved",
    "review": "Under review",
    "scanning": "Scanning…"
  },
  "legacyCategory": {
    "copay": "Copay",
    "insurance_premium": "Insurance premium",
    "medical_bill": "Medical bill",
    "prescription": "Prescription"
  },
  "row": {
    "delete": "Delete expense",
    "edit": "Edit expense",
    "needsDetails": "Add the merchant, date, amount and category.",
    "reading": "Reading the receipt…",
    "receipt": "Receipt",
    "scanFailed": "We couldn’t read this receipt — add the details."
  }
}
